/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import styled from '../../styles/styled';
import { SPOT_LOADER_TIME, } from '../constants';
import { getSpotSize } from './helpers';
import getOverrides from '../../overrides/helper';
const Container = styled.div `
  display: flex;
`;
const Dot = styled.div `
  border-radius: ${({ theme }) => theme.borders.radiusFull};
  position: relative;

  ${({ size }) => {
    const spot = getSpotSize({ size });
    return Object.assign({}, spot);
}}
  border-style: solid;
  border-color: ${({ theme }) => theme.colors.primary};
  animation: jumps ${SPOT_LOADER_TIME}s ease-in-out infinite;
  animation-delay: ${({ delay }) => `${delay}s`};
  @keyframes jumps {
    0%,
    100% {
      transform: translateY(0px);
    }
  
    50% {
      transform: translateY(-150%);
    }
  }
  ${({ $style }) => $style};
`;
const SpotLoader = (props) => {
    const firstDelay = SPOT_LOADER_TIME * (-0.45);
    const secondDotDelay = SPOT_LOADER_TIME * (-0.3);
    const thirdDotDelay = (SPOT_LOADER_TIME * (-0.15));
    const { overrides } = props;
    const DotOverride = getOverrides('Dot', overrides);
    return (React.createElement(Container, Object.assign({}, props),
        React.createElement(Dot, Object.assign({}, props, { delay: firstDelay }, DotOverride)),
        React.createElement(Dot, Object.assign({}, props, { delay: secondDotDelay }, DotOverride)),
        React.createElement(Dot, Object.assign({}, props, { delay: thirdDotDelay }, DotOverride))));
};
export default SpotLoader;
